var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a",
        {
          staticClass: "rbvChainsFilterMasterChain",
          class: _vm.masterClasses,
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              return _vm.toggleExpanded($event)
            },
          },
        },
        [
          _c(
            "i",
            {
              staticClass: "material-icons",
              on: {
                click: function ($event) {
                  return _vm.toggleSelected($event)
                },
              },
            },
            [_vm._v(_vm._s(_vm.checkboxIcon))]
          ),
          _c("span", { staticClass: "rbvChainsFilterMasterChainLabel" }, [
            _vm._v(_vm._s(_vm.chain.name)),
          ]),
          _c("i", { staticClass: "material-icons arrow" }, [
            _vm._v("arrow_drop_down"),
          ]),
        ]
      ),
      _c("transition", { attrs: { name: "tdMapBrandsShow" } }, [
        _vm.chain.expanded
          ? _c(
              "div",
              _vm._l(_vm.chain.brands, function (brand) {
                return _c("brand", { key: brand.id, attrs: { brand: brand } })
              }),
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }